import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MoneyCollectFilledSvg from "@ant-design/icons-svg/es/asn/MoneyCollectFilled";
import AntdIcon from "../components/AntdIcon";
var MoneyCollectFilled = function MoneyCollectFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MoneyCollectFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MoneyCollectFilled.displayName = 'MoneyCollectFilled';
}
export default /*#__PURE__*/React.forwardRef(MoneyCollectFilled);